// UI strings for an own word Peterson's word replaced (ownwords/superseded.tsx; engine
// own-word-supersede.ts): the notice on Tänään and on the new word's card, the dictionary marks.
// The *Ours strings: a better own word replaced it (Axel 2026-10-15, Supersession.byOurs).
// Finnish (default) and English side by side; en must have exactly the same shape.
import { defineArea } from '../area';

export const supersedeFi = {
  /** "Uusi virallinen sana: <official> korvaa sanan <ours>." (Axel's wording, 2026-10-09) */
  lead: 'Uusi virallinen sana:',
  replaces: 'korvaa sanan',
  badge: 'korvattu',
  badgeHint: 'Petersonin sana korvaa tämän oman sananne',
  replacedBy: 'Korvattu Petersonin sanalla',
  replacesOurs: 'Korvaa oman sananne',
  leadOurs: 'Uusi oma sana:',
  badgeHintOurs: 'Uusi oma sananne korvaa tämän sanan',
  replacedByOurs: 'Korvattu uudella omalla sanalla',
};

export const supersedeEn: typeof supersedeFi = {
  lead: 'New official word:',
  replaces: 'replaces',
  badge: 'replaced',
  badgeHint: "Peterson's word replaces this own word of yours",
  replacedBy: "Replaced by Peterson's word",
  replacesOurs: 'Replaces your own word',
  leadOurs: 'New own word:',
  badgeHintOurs: 'A new own word of yours replaces this word',
  replacedByOurs: 'Replaced by a new own word',
};

// Messages.supersede (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('supersede', supersedeFi, supersedeEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof supersedeFi> {}
}
